export default __webpack_public_path__ + "static/media/search.e0b696f3.svg";